import React from "react"
import { HiLocationMarker, HiOfficeBuilding } from "react-icons/hi"
import { FaTruck } from "react-icons/fa"
import { IoStorefront } from "react-icons/io5"
import { SourceData } from "./types/shipping"

interface ShippingLocationProps {
  location: any // LocationData | SourceData;
  shippingType: string
  deliveryType: string
  currentSource?: SourceData
}

const ShippingLocation: React.FC<ShippingLocationProps> = ({ location, shippingType, deliveryType, currentSource }) => {
  const formatLocation = (location: any) => {
    if ("criteria0" in location) {
      return `${location?.criteria3}, ${location?.criteria2}, ${location?.criteria1}, ${location?.criteria0}`
    } else if (location?.location) {
      return `${location?.location?.address}, ${location?.location?.commune}, ${location?.location?.province}, ${location?.location?.region}, ${location?.location?.country}`
    } else {
      return `${location?.address || ""}, ${location?.commune || ""}, ${location?.province || ""}, ${
        location?.region || ""
      }, ${location?.country || ""}`
    }
  }

  const getShippingTypeLabel = (type: string) => {
    switch (type) {
      case "HD":
        return "Entrega a Domicilio"
      case "SP":
        return "Retiro en Tienda"
      default:
        return type
    }
  }

  const isStorePickup = shippingType === "SP"

  return (
    <div className="space-y-4">
      {shippingType === "HD" ? (
        <div className="flex items-start gap-3">
          <div className="mt-0.5 bg-blue-100 p-2 rounded-full text-blue-600">
            {isStorePickup ? <HiOfficeBuilding size={18} /> : <HiLocationMarker size={18} />}
          </div>
          <div>
            <h3 className="font-medium text-gray-700 mb-1">
              {isStorePickup ? "Tienda de Retiro" : "Dirección de Entrega"}
            </h3>
            <p className="text-gray-800">{formatLocation(location)}</p>
            {isStorePickup && location?.name && <p className="text-sm text-gray-600 mt-1">{location?.name}</p>}
          </div>
        </div>
      ) : null}

      {shippingType === "HD" ? (
        <div className="flex items-start gap-3">
          <div className="mt-0.5 bg-green-100 p-2 rounded-full text-green-600">
            <FaTruck size={18} />
          </div>
          <div>
            <h3 className="font-medium text-gray-700 mb-1">Método de Envío</h3>
            <p className="text-gray-800">{getShippingTypeLabel(shippingType)}</p>
            {deliveryType && <p className="text-sm text-gray-600 mt-1">{deliveryType}</p>}
          </div>
        </div>
      ) : null}

      {currentSource && (
        <div className="flex items-start gap-3">
          <div className="mt-0.5 bg-red-100 p-2 rounded-full text-red-600">
            <IoStorefront size={18} />
          </div>
          <div>
            <h3 className="font-medium text-gray-700 mb-1">Tienda/Bodega</h3>
            <p className="text-sm text-gray-600 mt-1">
              {currentSource?.id} / {currentSource?.name}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default ShippingLocation
